/**
 * Single source of version truth for the frontend.
 *
 * This must match the repository root VERSION file and the backend version
 * package. A CI stage asserts all three agree, so a release cannot ship with
 * the interface reporting a different version from the engine that computed
 * the result.
 */
export const APPLICATION_VERSION = 'v26.9.26.1';
